module.exports = __webpack_public_path__ + "static/img/JA.94ecf7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banners/pc/JA.png
// module id = 1KPQ
// module chunks = 1